import Jumbotron from "../Sections/contact/Jumbotron";
import ContactForm from "../Sections/contact/ContactForm";
import { useGetSettingQuery } from "../../../Redux/Apis/siteApi";

function ContactUs() {
    const { data: {contact} } = useGetSettingQuery()

    return ( 
        <>
        {contact.jumbotron && <Jumbotron/>}
        {contact.contact_form && <ContactForm/>}
        </>
    );
}

export default ContactUs;